{
  "title": "Reset Your Password",
  "subtitle": "Enter your email to receive a reset link",
  "emailLabel": "Email",
  "sendButton": "Send Reset Link",
  "sendingButton": "Sending...",
  "backToLogin": "Back to login",
  "successTitle": "Check Your Email",
  "successMessage": "We sent a password reset link to",
  "expiryNote": "The link will expire in 1 hour",
  "errors": {
    "emailRequired": "Please enter your email address",
    "invalidEmail": "Please enter a valid email address",
    "sendFailed": "Failed to send reset email. Please try again."
  }
}
